import React, { forwardRef, Ref, SVGProps } from 'react'

function _IconQuickEdit(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      ref={ref}
    >
      <path
        d="M9.33335 1.33398H4.00002C3.6464 1.33398 3.30726 1.47446 3.05721 1.72451C2.80716 1.97456 2.66669 2.3137 2.66669 2.66732V13.334C2.66669 13.6876 2.80716 14.0267 3.05721 14.2768C3.30726 14.5268 3.6464 14.6673 4.00002 14.6673H12C12.3536 14.6673 12.6928 14.5268 12.9428 14.2768C13.1929 14.0267 13.3334 13.6876 13.3334 13.334V5.33398L9.33335 1.33398Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33331 1.33398V5.33398H13.3333"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10H10"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconQuickEdit = forwardRef(_IconQuickEdit)
